import { render } from "./AttrCompare.vue?vue&type=template&id=4879416d&scoped=true"
import script from "./AttrCompare.vue?vue&type=script&lang=js"
export * from "./AttrCompare.vue?vue&type=script&lang=js"

import "./AttrCompare.vue?vue&type=style&index=0&id=4879416d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4879416d"],['__file',"src/components/widgets/components_core/AttrCompare.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4879416d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4879416d', __exports__)) {
    api.reload('4879416d', __exports__)
  }
  
  module.hot.accept("./AttrCompare.vue?vue&type=template&id=4879416d&scoped=true", () => {
    api.rerender('4879416d', render)
  })

}


export default __exports__